/*
 * CLTR: tall sticky product details.
 *
 * Horizon pins the product details column to the top of the screen while the gallery scrolls.
 * When the column is taller than the screen (a product description on a laptop, say), its lower
 * half stays out of view until the whole gallery has gone past. This gives the column a top
 * offset that lets it scroll until its bottom is on screen, then pins it there. Columns that fit
 * keep Horizon's normal offset, and below 750px the column isn't sticky, so top has no effect.
 */
const SELECTOR = '#MainContent .sticky-content--desktop';
const observed = new WeakSet();

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) sync(entry.target);
});

/** @param {HTMLElement} element */
function sync(element) {
  const height = String(Math.ceil(element.offsetHeight));
  if (element.dataset.cltrStickyH === height && element.style.top) return;
  element.dataset.cltrStickyH = height;
  element.style.top = `min(var(--sticky-header-offset, 0px), calc(100vh - ${height}px - 1.5rem))`;
}

function scan() {
  for (const element of document.querySelectorAll(SELECTOR)) {
    if (!(element instanceof HTMLElement)) continue;
    if (!observed.has(element)) {
      observed.add(element);
      resizeObserver.observe(element);
    }
    sync(element);
  }
}

// Variant changes re-render the section and can replace the column or reset its style attribute.
let queued = false;
new MutationObserver((records) => {
  if (queued) return;
  const relevant = records.some(
    (record) =>
      record.type === 'childList' ||
      (record.target instanceof Element && record.target.matches(SELECTOR))
  );
  if (!relevant) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    scan();
  });
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

scan();
